import styled from "@emotion/styled"
import getMediaQuery from "css/breakpoints"
import { fullGrid } from "css/grid"
import { body50, headline30, headline50 } from "css/text"

import DownloadCard from "./DownloadCard"

const Root = styled.section`
  /* margin-block-start: 6.25rem; */
`

const Grid = styled.div`
  ${fullGrid}
`

const LargeParagraph = styled.p`
  ${headline50}
  grid-column: col 1 / col -1;
  margin-top: 3.75rem;

  ${getMediaQuery("m")} {
    grid-column: col 2 / col -2;
  }

  .green {
    color: rgb(var(--green));
  }
`

const Title = styled.h2`
  ${headline30}
  grid-column: col 1 / col -1;
  margin-block-start: 6.25rem;
  margin-block-end: 1.25rem;
`

const Paragraph = styled.p`
  ${body50}
  grid-column: col 1 / col -1;
  margin-block-start: 3.75rem;

  ${getMediaQuery("m")} {
    grid-column: col 2 / col -2;
  }
`

const List = styled.ul`
  grid-column: col 1 / col -1;
  display: grid;
  grid-template-columns: ${props => (props.downloadType === "userGuide" ? "1fr" : "1fr 1fr")};
  grid-gap: var(--grid-gap);
  margin-block-start: 6.25rem;

  h2 + & {
    margin-block-start: 0;
  }

  ${getMediaQuery("m")} {
    grid-gap: var(--grid-gap);
    grid-column: col 1 / col -1;
    grid-template-columns: 1fr 1fr;
    padding-inline: 0;
  }

  ${getMediaQuery("xl")} {
    grid-template-columns: 1fr 1fr 1fr;
  }

  > li {
    margin-bottom: 0;
  }
`

export default function DonwloadPage(props) {
  const {
    large_paragraph: largeParagraph,
    section_title: sectionTitle,
    paragraph,
    download_type: downloadType,
    download_button_label: downloadLabel,
    elements,
    modal,
  } = props

  const addGreen = text => {
    // add green between % in sentence
    const split = text.split("%")
    split.forEach((item, index) => {
      if (index % 2 !== 0) {
        split[index] = `<span class='green'>${item}</span>`
      }
    })

    return split.join("")
  }

  return (
    <Root>
      {/* <PageHeading kicker={kicker} title={title} color='--light-black' isStatic={true} isOneTitle /> */}
      {(largeParagraph || paragraph) && (
        <Grid>
          {largeParagraph && <LargeParagraph dangerouslySetInnerHTML={{ __html: addGreen(largeParagraph) }} />}
          {paragraph?.block?.map(el => (
            <Paragraph key={el._metadata?.uid}>{el.paragraph}</Paragraph>
          ))}
        </Grid>
      )}
      {downloadType === "wallpaper" && (
        <Grid>
          {sectionTitle && <Title>{sectionTitle}</Title>}
          <List>
            {elements?.map(element => (
              <DownloadCard
                key={element.title}
                {...element}
                modal={modal}
                downloadType='wallpaper'
                cta={{
                  external: element.download_path || true,
                  text: downloadLabel || "Download",
                  icon: "download",
                  download: true,
                }}
              />
            ))}
          </List>
        </Grid>
      )}
      {downloadType === "brochure" && (
        <Grid>
          {sectionTitle && <Title>{sectionTitle}</Title>}
          <List>
            {elements?.map(element => (
              <DownloadCard
                key={element.title}
                {...element}
                modal={modal}
                downloadType='brochure'
                cta={{
                  external: element.download_path || true,
                  text: downloadLabel || "Download",
                  icon: "download",
                  download: true,
                }}
              />
            ))}
          </List>
        </Grid>
      )}
      {downloadType === "userGuide" && (
        <Grid>
          {sectionTitle && <Title>{sectionTitle}</Title>}
          <List downloadType={downloadType}>
            {elements?.map(element => (
              <DownloadCard
                key={element.title}
                {...element}
                modal={modal}
                downloadType='userGuide'
                cta={{
                  external: element.download_path || true,
                  text: downloadLabel || "Download",
                  icon: "download",
                  download: true,
                }}
              />
            ))}
          </List>
        </Grid>
      )}
    </Root>
  )
}
